// extracted by mini-css-extract-plugin
export default {"modifierCounterBtn":"OrderItemFooter_modifierCounterBtn__GOwjt","cancelBtn":"OrderItemFooter_cancelBtn__GuMNR"};